import { Routes } from '@angular/router';
import { ButtonBarPageComponent } from './pages/button-bar/button-bar.component';
import { ThemePageComponent } from './pages/theme/theme.component';
import { ComponentsPageComponent } from './pages/components/components.component';
import { PriceComponentTestsPageComponent } from './pages/price-component-tests/price-component-tests.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'products',
    pathMatch: 'full',
  },
  {
    path: 'button-bar',
    component: ButtonBarPageComponent,
  },
  {
    path: 'components',
    component: ComponentsPageComponent,
  },
  {
    path: 'price-tests',
    component: PriceComponentTestsPageComponent,
  },
  {
    path: 'theme',
    component: ThemePageComponent,
  },
];
